import { createContext, useState } from "react";
import { postToken, refreshAccessToken, checkTokenExpired } from "../Service/Authentication";
import { useNavigate } from "react-router-dom";
export const AuthContext = createContext({});

export const AuthProvider = (props) => {

    const [isLogin, setIsLogin] = useState(false);
    const [accessToken, setAccessToken] = useState();
    const [tokenExpiration, setTokenExpiration] = useState(0);
    const [refreshToken, setRefreshToken] = useState();

    function updateIsLogin(valor) {
        setIsLogin(valor);
    }

    async function getTokenApi(user, pass) {
        try {
            const data = await postToken(user, pass);

            if (data.access_token) {
                updateAccessToken(data.access_token, data.expires_in, data.refresh_token);
            } else {
                // setErrorLogin(JSON.parse(data.error).Msj);
            }

            return data;
        } catch (error) {
            console.error('error', error);
            //throw error;
        }
    }

    const navigate = useNavigate();

    async function getRefreshToken(refreshToken) {
        try {
            const data = await refreshAccessToken(refreshToken);

            if (data.access_token) {
                await updateAccessToken(data.access_token, data.expires_in, data.refresh_token);
            } else {
                // setErrorLogin(JSON.parse(data.error).Msj);
                updateIsLogin(false);
                navigate('/');
            }

            return data;
        } catch (error) {
            updateIsLogin(false);
            navigate('/');
            //throw error;
        }
    }

    function updateAccessToken(token, expiresIn, refreshToken) {
        setAccessToken(token);

        const expirationDate = new Date();
        expirationDate.setSeconds(expirationDate.getSeconds() + (expiresIn - 120));
        setTokenExpiration(expirationDate.getTime());

        setRefreshToken(refreshToken);

        // console.log('REFRESH TOKEN', refreshToken)

    }

    const isAccessTokenValid = async () => {
        try {
            const data = await checkTokenExpired(accessToken);

            if (data.ExceptionName === "UnisyncException") {
                await getRefreshToken(refreshToken);
            }
        } catch (error) {
            console.error('error', error);
            //throw error;
        }
        // console.log('CONSULTA SI ES VALIDO', new Date(tokenExpiration))
        // return new Date(tokenExpiration) > Date.now();
    };

    const getAccessToken = async () => {
        if (accessToken && isAccessTokenValid()) {
            // console.log("ME PARECE Q ESTOY VENCIDO")
            return accessToken;
        } else {
            //console.log(refreshToken)

            if (refreshToken) {
                return await getRefreshToken(refreshToken).then(() => accessToken)
            }
        }
    }

    return (<AuthContext.Provider value={{ getAccessToken, accessToken, updateAccessToken, isAccessTokenValid, setAccessToken, updateIsLogin, isLogin, tokenExpiration, getTokenApi }}>
        {props.children}
    </AuthContext.Provider>);
}

